import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const RegprofAdditionalDocStepFiling = () => {
  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.regprofAdditionalDoc}
      appId={regprofAdditionalDocForm.id}
      allowedFileApplicationAction={false}
    />
  );
};
export default RegprofAdditionalDocStepFiling;
